module.exports = __webpack_public_path__ + "static/media/directv.057c5d9e.jpg";